module.exports = __webpack_public_path__ + "static/img/15.07a66f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/zh/15.png
// module id = m4Sg
// module chunks = 0